import { useMutation } from '@tanstack/react-query';
import { useLocalizeMessage, useToastNotification } from 'libs.nucleus';
export const useSendConsentInvite = ({ apiClient, getApiErrorMessage, onSuccess }) => {
    const translate = useLocalizeMessage();
    const { addNotification } = useToastNotification();
    return useMutation({
        mutationFn: async ({ body }) => {
            if (!apiClient) {
                throw new Error('API client not defined');
            }
            const response = await apiClient.post('/v2/routes/econsent/invite', body);
            return response?.data;
        },
        onSuccess: () => {
            addNotification({
                title: '',
                subtitle: translate('info.create_consent.invitation_sent'),
                type: 'success',
            });
            onSuccess?.();
        },
        onError: (error) => {
            const message = getApiErrorMessage?.(error);
            addNotification({
                title: '',
                subtitle: message ?? translate('error.generic'),
                type: 'error',
            });
        },
    });
};
